exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user_icon[data-v-30742bd3]{width:70px}", ""]);

// exports
